module.exports = __webpack_public_path__ + "static/media/dario_alineador_375.ea4da6f7.jpg";